import { configureStore } from '@reduxjs/toolkit/react';
import { setupListeners } from '@reduxjs/toolkit/query/react';

import { baseApi } from '@core/api/base-api';

import ip from '@features/auth/slices/ip-slice';
import printerLog from '@features/printer/slices/printer-log-slice';

// Point de composition : seul endroit de `core` autorisé à connaître les reducers des features.
export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    ip,
    printerLog,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
